/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Device_Limit_Reached_MessageInputs */

const en_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have reached your device limit for ${i?.displayName}.`)
};

const id_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda telah mencapai batas device untuk ${i?.displayName}.`)
};

const ms_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda telah mencapai had peranti untuk ${i?.displayName}.`)
};

const ca_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Has arribat al límit d'aparells per a ${i?.displayName}.`)
};

const cs_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dosáhli jste limitu zařízení pro ${i?.displayName}.`)
};

const da_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har nået din enhedsgrænse for ${i?.displayName}.`)
};

const de_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sie haben Ihr Gerätelimit für ${i?.displayName} erreicht.`)
};

const et_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oled saavutanud ${i?.displayName} seadmete piirangu.`)
};

const es_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Has alcanzado el límite de dispositivos para ${i?.displayName}.`)
};

const fr_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez atteint la limite d’appareils pour ${i?.displayName}.`)
};

const hr_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dosegli ste ograničenje uređaja za ${i?.displayName}.`)
};

const it_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai raggiunto il limite di dispositivi per ${i?.displayName}.`)
};

const lv_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esat sasniedzis ${i?.displayName} ierīču limitu.`)
};

const lt_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pasiekėte ${i?.displayName} įrenginių ribą.`)
};

const hu_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elérted a ${i?.displayName} eszközkorlátját.`)
};

const nl_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je hebt je devicelimiet voor ${i?.displayName} bereikt.`)
};

const nb_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har nådd enhetsgrensen din for ${i?.displayName}.`)
};

const pl_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Osiągnięto limit urządzeń dla ${i?.displayName}.`)
};

const pt_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você atingiu o limite de dispositivos para o ${i?.displayName}.`)
};

const ro_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ai atins limita de dispozitive pentru ${i?.displayName}.`)
};

const sk_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dosiahli ste limit zariadení pre ${i?.displayName}.`)
};

const sl_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dosegli ste omejitev naprav za ${i?.displayName}.`)
};

const fi_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olet saavuttanut laiterajan tuotteelle ${i?.displayName}.`)
};

const sv_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har nått din enhetsgräns för ${i?.displayName}.`)
};

const vi_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bạn đã đạt đến giới hạn thiết bị cho ${i?.displayName}.`)
};

const tr_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} için cihaz sınırınıza ulaştınız.`)
};

const el_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Έχετε φτάσει το όριο συσκευών για το ${i?.displayName}.`)
};

const bg_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Достигнахте лимита на устройства за ${i?.displayName}.`)
};

const ru_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы достигли лимита устройств для ${i?.displayName}.`)
};

const sr_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Достигли сте лимит уређаја за ${i?.displayName}.`)
};

const uk_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ви досягли ліміту пристроїв для ${i?.displayName}.`)
};

const ka_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`მიაღწიეთ მოწყობილობების ლიმიტს ${i?.displayName}-ისთვის.`)
};

const hi_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आप ${i?.displayName} के लिए अपनी डिवाइस सीमा तक पहुँच गए हैं।`)
};

const th_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณได้ถึงขีดจำกัดของอุปกรณ์สำหรับ ${i?.displayName} แล้ว`)
};

const ko_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}의 디바이스 한도에 도달했습니다.`)
};

const zh_tw_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您已達到 ${i?.displayName} 的裝置數量上限。`)
};

const ja_device_limit_reached_message = /** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} のデバイス制限に達しました。`)
};

/** @type {(inputs: Device_Limit_Reached_MessageInputs) => LocalizedString} */
const zh_device_limit_reached_message = en_device_limit_reached_message;

/**
* | output |
* | --- |
* | "You have reached your device limit for {displayName}." |
*
* @param {Device_Limit_Reached_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const device_limit_reached_message = /** @type {((inputs: Device_Limit_Reached_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_Limit_Reached_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_device_limit_reached_message(inputs)
	if (locale === "ms") return ms_device_limit_reached_message(inputs)
	if (locale === "ca") return ca_device_limit_reached_message(inputs)
	if (locale === "cs") return cs_device_limit_reached_message(inputs)
	if (locale === "da") return da_device_limit_reached_message(inputs)
	if (locale === "de") return de_device_limit_reached_message(inputs)
	if (locale === "et") return et_device_limit_reached_message(inputs)
	if (locale === "es") return es_device_limit_reached_message(inputs)
	if (locale === "fr") return fr_device_limit_reached_message(inputs)
	if (locale === "hr") return hr_device_limit_reached_message(inputs)
	if (locale === "it") return it_device_limit_reached_message(inputs)
	if (locale === "lv") return lv_device_limit_reached_message(inputs)
	if (locale === "lt") return lt_device_limit_reached_message(inputs)
	if (locale === "hu") return hu_device_limit_reached_message(inputs)
	if (locale === "nl") return nl_device_limit_reached_message(inputs)
	if (locale === "nb") return nb_device_limit_reached_message(inputs)
	if (locale === "pl") return pl_device_limit_reached_message(inputs)
	if (locale === "pt") return pt_device_limit_reached_message(inputs)
	if (locale === "ro") return ro_device_limit_reached_message(inputs)
	if (locale === "sk") return sk_device_limit_reached_message(inputs)
	if (locale === "sl") return sl_device_limit_reached_message(inputs)
	if (locale === "fi") return fi_device_limit_reached_message(inputs)
	if (locale === "sv") return sv_device_limit_reached_message(inputs)
	if (locale === "vi") return vi_device_limit_reached_message(inputs)
	if (locale === "tr") return tr_device_limit_reached_message(inputs)
	if (locale === "el") return el_device_limit_reached_message(inputs)
	if (locale === "bg") return bg_device_limit_reached_message(inputs)
	if (locale === "ru") return ru_device_limit_reached_message(inputs)
	if (locale === "sr") return sr_device_limit_reached_message(inputs)
	if (locale === "uk") return uk_device_limit_reached_message(inputs)
	if (locale === "ka") return ka_device_limit_reached_message(inputs)
	if (locale === "hi") return hi_device_limit_reached_message(inputs)
	if (locale === "th") return th_device_limit_reached_message(inputs)
	if (locale === "ko") return ko_device_limit_reached_message(inputs)
	if (locale === "zh") return zh_device_limit_reached_message(inputs)
	if (locale === "zh-tw") return zh_tw_device_limit_reached_message(inputs)
	if (locale === "ja") return ja_device_limit_reached_message(inputs)
	return en_device_limit_reached_message(inputs)
});